import { render, staticRenderFns } from "./CadastroPerfil.vue?vue&type=template&id=44055d6b&scoped=true&"
import script from "./CadastroPerfil.vue?vue&type=script&lang=js&"
export * from "./CadastroPerfil.vue?vue&type=script&lang=js&"
import style0 from "./CadastroPerfil.vue?vue&type=style&index=0&id=44055d6b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44055d6b",
  null
  
)

export default component.exports